import { createStyles, makeStyles } from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";

import { NoResultsText, RelodeApiError, RelodeTheme } from "../../..";

const useLocalStyles = makeStyles((theme: RelodeTheme) =>
    createStyles({
        noResultsText: {
            textAlign: "left",
            display: "flex",
        },
    })
);

export const MarketResearchError = (props: {
    title: string;
    error: RelodeApiError;
    className?: string;
    padding?: boolean;
}) => {
    const { error, title, className, padding } = props;
    const classes = useLocalStyles({});

    const message = error.isBadRequest()
        ? `Error retrieving ${title} data`
        : error.isNotFound()
        ? `${error.summary}`
        : error.friendlyMessages ??
          "An unexpected error occurred.  Please try again.";

    const noResultsClasses = classnames(
        {
            [className]: !!className,
        },
        classes.noResultsText
    );

    return (
        <NoResultsText className={noResultsClasses} error padding={padding}>
            {message}
        </NoResultsText>
    );
};
